import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

import LoanScheduleManager from './LoanScheduleManager';
export default function ReschedulePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="ReschedulePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('reschedule')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="App">
                        <LoanScheduleManager />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
